var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputfield",staticClass:"text-end form-control",class:_vm.inputClass,attrs:{"type":"text","name":_vm.name,"readonly":_vm.readonly},domProps:{"value":_vm.val},on:{"input":_vm.onInput,"keypress":_vm.onlyForCurrency,"blur":_vm.formatNumber}})
}
var staticRenderFns = []

export { render, staticRenderFns }